module.exports = __webpack_public_path__ + "media/1.66e96513.mp3";